var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitor01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8 21.5H16M12 17.5V21.5M6.8 17.5H17.2C18.8802 17.5 19.7202 17.5 20.362 17.173C20.9265 16.8854 21.3854 16.4265 21.673 15.862C22 15.2202 22 14.3802 22 12.7V8.3C22 6.61984 22 5.77976 21.673 5.13803C21.3854 4.57354 20.9265 4.1146 20.362 3.82698C19.7202 3.5 18.8802 3.5 17.2 3.5H6.8C5.11984 3.5 4.27976 3.5 3.63803 3.82698C3.07354 4.1146 2.6146 4.57354 2.32698 5.13803C2 5.77976 2 6.61984 2 8.3V12.7C2 14.3802 2 15.2202 2.32698 15.862C2.6146 16.4265 3.07354 16.8854 3.63803 17.173C4.27976 17.5 5.11984 17.5 6.8 17.5Z",
    stroke: "#4F9CF9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor01);
export default __webpack_public_path__ + "static/media/monitor-01.781872a951fcc238fef37439806adb91.svg";
export { ForwardRef as ReactComponent };